import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/blood-pressure-calculator',
  component: () => import('../../routes/BloodPressureCalculator.svelte'),
  card: {
    id: 'blood-pressure-calculator',
    title: 'Blood Pressure Calculator',
    description:
      'Check your blood pressure reading and understand what it means for your health. Includes pulse pressure and MAP.',
    icon: 'favorite',
    iconBgClass: 'bg-red-50',
    iconTextClass: 'text-red-600',
    href: '/blood-pressure-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Blood Pressure Calculator – Check Your BP Reading',
    description:
      'Free blood pressure calculator to classify your reading (Normal, Elevated, Hypertension) and calculate pulse pressure and mean arterial pressure (MAP).',
  },
};

export default meta;